import graphApiSlice from 'src/shared/state/api-slices/graphApiSlice';

import { HabitatInsightsGeoJson } from 'src/shared/types';
import {
    HabitatInsightsUploadQueryResult,
    habitatInsightsUploadQuery,
    createProjectInfoQuery,
    habitatInsightsProjectsQuery,
    HabitatInsightsProjectsQueryResult,
} from './queries/habitatInsightsUploadQuery';

type HabitatInsightsUploadQueryParams = {
    portfolioId?: string;
    project: {
        projectId: string;
        customerId?: string;
        customerName?: string;
        projectName: string;
        country: string;
    };
    sites: HabitatInsightsGeoJson[];
    isHlcaProject?: boolean;
    runCloudJobs: boolean;
};

type CreateProjectInfoQueryParams = {
    projectId: string;
    customerId: string;
    projectName: string;
    projectCode: string;
    subscriptionType: string;
    country: string;
    leadName: string;
    leadEmail: string;
    leadRole: string;
};

const habitatInsightsUploadGraphSlice = graphApiSlice.injectEndpoints({
    endpoints: builder => ({
        habitatInsightsUpload: builder.mutation<boolean, HabitatInsightsUploadQueryParams>({
            query: ({ portfolioId, project, sites, isHlcaProject, runCloudJobs }) => ({
                body: habitatInsightsUploadQuery,
                variables: {
                    input: {
                        portfolioId,
                        project,
                        sites: JSON.parse(JSON.stringify(sites)),
                        isHlcaProject,
                        runCloudJobs: runCloudJobs ?? true,
                    },
                },
            }),
            transformResponse: (response: HabitatInsightsUploadQueryResult) => {
                return response.addProjectSites ?? false;
            },
        }),
        createProjectInfo: builder.mutation<boolean, CreateProjectInfoQueryParams>({
            query: params => ({
                body: createProjectInfoQuery,
                variables: { input: { ...params } },
            }),
        }),
        habitatInsightsProjects: builder.query<HabitatInsightsProjectsQueryResult, { customerId: string }>({
            query: params => ({
                body: habitatInsightsProjectsQuery,
                variables: params,
            }),
        }),
    }),
});

export const {
    useLazyHabitatInsightsProjectsQuery,
    useHabitatInsightsUploadMutation,
    useCreateProjectInfoMutation,
    useHabitatInsightsProjectsQuery,
} = habitatInsightsUploadGraphSlice;
